export const applicanttrackingclientsdata = [
  {
    Name: "John Doe",
    Company: "Tech Solutions",
    Phone: "+1 555-1234",
    Email: "johndoe@techsol.com",
    Location: "New York, USA",
    IsActive: "Yes",
    Website: "www.techsol.com",
  },
  {
    Name: "Jane Smith",
    Company: "Green Industries",
    Phone: "+1 555-5678",
    Email: "jane.smith@greenind.com",
    Location: "Los Angeles, USA",
    IsActive: "Yes",
    Website: "www.greenind.com",
  },
  {
    Name: "Robert Brown",
    Company: "Bright Future",
    Phone: "+44 20 7946",
    Email: "robert.b@brightfuture.co",
    Location: "London, UK",
    IsActive: "No",
    Website: "www.brightfuture.co",
  },
  {
    Name: "Maria Garcia",
    Company: "Web Works",
    Phone: "+34 912-3456",
    Email: "maria.garcia@webworks.es",
    Location: "Madrid, Spain",
    IsActive: "Yes",
    Website: "www.webworks.es",
  },
  {
    Name: "Mike Johnson",
    Company: "Digital Corp",
    Phone: "+1 555-8765",
    Email: "mike@digitalcorp.com",
    Location: "Toronto, Canada",
    IsActive: "Yes",
    Website: "www.digitalcorp.com",
  },
  {
    Name: "Emily White",
    Company: "CloudNet",
    Phone: "+1 555-4321",
    Email: "emily.white@cloudnet.com",
    Location: "Chicago, USA",
    IsActive: "Yes",
    Website: "www.cloudnet.com",
  },
  {
    Name: "James Wilson",
    Company: "Global Markets",
    Phone: "+61 2 9876 54",
    Email: "james.wilson@global.com",
    Location: "Sydney, Australia",
    IsActive: "No",
    Website: "www.globalmarkets.com",
  },
  {
    Name: "Sarah Lee",
    Company: "InnovateTech",
    Phone: "+1 555-9087",
    Email: "sarah.lee@innovate.com",
    Location: "San Francisco, USA",
    IsActive: "Yes",
    Website: "www.innovate.com",
  },
  {
    Name: "Michael Davis",
    Company: "SolarTech",
    Phone: "+44 20 8888 99",
    Email: "michael.davis@solartech.co.uk",
    Location: "Manchester, UK",
    IsActive: "Yes",
    Website: "www.solartech.co.uk",
  },
  {
    Name: "Olivia Brown",
    Company: "NextGen Ventures",
    Phone: "+1 555-3345",
    Email: "olivia@nextgen.com",
    Location: "Vancouver, Canada",
    IsActive: "Yes",
    Website: "www.nextgen.com",
  },
  {
    Name: "David Clark",
    Company: "Alpha Solutions",
    Phone: "+1 555-2345",
    Email: "david.clark@alphasolutions.com",
    Location: "Boston, USA",
    IsActive: "Yes",
    Website: "www.alphasolutions.com",
  },
  {
    Name: "Laura Miller",
    Company: "SmartTech",
    Phone: "+44 20 1122 33",
    Email: "laura.miller@smarttech.co.uk",
    Location: "Manchester, UK",
    IsActive: "Yes",
    Website: "www.smarttech.co.uk",
  },
  {
    Name: "Chris Anderson",
    Company: "Innovative Designs",
    Phone: "+1 555-4567",
    Email: "chris@innovativedesigns.com",
    Location: "Austin, USA",
    IsActive: "No",
    Website: "www.innovativedesigns.com",
  },
  {
    Name: "Alice Johnson",
    Company: "Blue Ocean Ventures",
    Phone: "+1 555-6543",
    Email: "alice@blueocean.com",
    Location: "Miami, USA",
    IsActive: "Yes",
    Website: "www.blueocean.com",
  },
  {
    Name: "Robert Martinez",
    Company: "FutureTech Innovations",
    Phone: "+34 915-6789",
    Email: "robert.martinez@futuretech.com",
    Location: "Barcelona, Spain",
    IsActive: "Yes",
    Website: "www.futuretech.com",
  },
  {
    Name: "Sophie Green",
    Company: "TechX Solutions",
    Phone: "+1 555-8765",
    Email: "sophie.green@techxsolutions.com",
    Location: "Los Angeles, USA",
    IsActive: "Yes",
    Website: "www.techxsolutions.com",
  },
  {
    Name: "Daniel Lee",
    Company: "NextWave Tech",
    Phone: "+61 2 4567 89",
    Email: "daniel.lee@nextwave.com",
    Location: "Sydney, Australia",
    IsActive: "No",
    Website: "www.nextwave.com",
  },
  {
    Name: "Olivia Harris",
    Company: "Cloud Horizon",
    Phone: "+1 555-2234",
    Email: "olivia.harris@cloudhorizon.com",
    Location: "San Francisco, USA",
    IsActive: "Yes",
    Website: "www.cloudhorizon.com",
  },
  {
    Name: "John Williams",
    Company: "Prime Innovations",
    Phone: "+44 20 2233 44",
    Email: "john.williams@primeinnovations.co.uk",
    Location: "London, UK",
    IsActive: "Yes",
    Website: "www.primeinnovations.co.uk",
  },
  {
    Name: "Sophia Thompson",
    Company: "Digital Horizon",
    Phone: "+1 555-9087",
    Email: "sophia.thompson@digitalhorizon.com",
    Location: "Chicago, USA",
    IsActive: "Yes",
    Website: "www.digitalhorizon.com",
  },
];
